import { stakeChecker } from '@orbital/games-frontend-library';

export const helperSendBet = (
	stake: string | number,
	handleStake: any,
	sendBet: any,
	maxBet: any,
	minBet: any,
	balance: string,
	handleNotification: any,
	activeRisk: any,
	activeRows: any,
	setballsOnBoard: any,
	sendSettings: any,
	lastStake: any,
	setlastStake: any,
	setisAutoOn: any,
	setfinalBalance: React.Dispatch<React.SetStateAction<number>>,
	setBetSent: any
) => {
	if (stakeChecker(stake, maxBet, minBet, balance, handleNotification)) {
		handleStake(stake.toString());

		sendBet(activeRisk.toLowerCase(), +activeRows, +stake);
		setBetSent(true);

		// setfinalBalance((state) => {
		//   return state - parseFloat(stake as string);
		// });

		setballsOnBoard((b: number) => b + 1);

		if (stake !== lastStake) {
			sendSettings();
			setlastStake(stake);
		}
	} else {
		setisAutoOn(false);
	}
};
